import * as React from 'react'
import { useData } from './hooks'
import { Filters } from './Filters'
import { Results } from './Results'
import { LocAndSvcs } from './LocAndSvcs'
import { LoadingSpinner } from '@sales-center/components'

export function SchedulingWizard() {
  const loading = useData()

  return loading ? (
    <LoadingSpinner />
  ) : (
    <>
      <LocAndSvcs />
      <Filters />
      <Results />
    </>
  )
}
